<!-- Header -->
<div class="ph-header bg-accent sm:bg-white w-full flex-0 shadow print:hidden">
<div class="flex h-13 sm:h-16 items-center px-3 md:px-6">
    <!-- Menu toggle button (show only if requested) -->
    @if (showMenuToggle) {
        <button
            mat-icon-button
            class="mr-2"
            (click)="onMenuToggle()"
            aria-label="Toggle navigation menu"
        >
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
    }

    <!-- Team switcher chip (mobile only, hidden in Torneos) -->
    @if (showTeamSwitcher()) {
        @let team = teamContext.selectedTeam();
        @if (team) {
            <button
                class="ph-team-chip flex md:hidden items-center gap-2 pl-1 pr-1.5 py-1 rounded-xl max-w-[235px]"
                [class.open]="isPickerOpen()"
                [class.ph-team-chip--past]="isPastSeason()"
                (click)="openTeamPicker()"
            >
                <!-- Squircle -->
                <span
                    class="w-6 h-6 rounded-lg shrink-0 flex items-center justify-center text-white font-extrabold text-xs shadow-[inset_0_0_0_1px_rgba(255,255,255,0.12)]"
                    [class.grayscale]="isPastSeason()"
                    [class]="teamColorClass(team)"
                >
                    {{ team.initials }}
                </span>

                <!-- Name (+ year in amber when viewing a past season) -->
                <span class="flex items-baseline gap-1 min-w-0">
                    <span class="truncate text-md font-bold text-white">
                        {{ team.name }}
                    </span>
                    @if (isPastSeason() && pastSeasonYear()) {
                        <span class="shrink-0 text-[11px] font-semibold text-amber-400">
                            &middot;&nbsp;{{ pastSeasonYear() }}
                        </span>
                    }
                </span>

                <!-- Chevron (rotates 180° when sheet is open) -->
                <mat-icon class="ph-team-chip__chevron shrink-0 text-white/60 ph-icon-20">
                    expand_more
                </mat-icon>
            </button>
        }
    } @else {
        <!-- Fallback wordmark when switcher is hidden (e.g. Torneos) -->
        <div class="flex md:hidden items-center gap-2">
            <img
                class="w-8 h-8"
                src="images/logo/padelhub_logo.png"
                alt="PadelHub Logo"
            />
            <span class="text-lg font-semibold text-blue-100 hidden sm:inline">PadelHub</span>
        </div>
    }

    <!-- Spacer -->
    <div class="flex-1"></div>

    <!-- Right side components -->
    <div class="flex items-center pl-2">
        <user></user>
    </div>
</div>
</div>
